import { ExclamationCircleIcon } from '@heroicons/react/20/solid';
import { useContext } from 'react';
import { Localization } from '../../../config/localization/localization';
import { LanguageSelectorContext } from '../../../context/LanguageSelectorContext';

export const PasswordWarning = () => {

    const { selectedLanguage } = useContext(LanguageSelectorContext);
    const localization = new Localization(selectedLanguage);
    
    return (
        <div className={'flex flex-row items-center bg-red-500 p-1.5 text-white dark:bg-red-300 dark:text-gray-100'}>
            <ExclamationCircleIcon className={'mr-1 h-5 w-5 flex-shrink-0'} />
            {localization.translate('registration.passwordWarning')}
        </div>
    );
};